import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaCadastroControleTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID, IDEmissao, VersaoDocumento, CETIP, IDUsuario, DataCalculo, PUPAR, PUMTM, PercPUPAR, Duration,
        } = newRow

        const body = {
            "IDEmissao": IDEmissao,
            "VersaoDocumento": VersaoDocumento,
            "CETIP": CETIP,
            "IDUsuario": IDUsuario,
            "DataCalculo": DataCalculo,
            "PUPAR": PUPAR,
            "PUMTM": PUMTM,
            "PercPUPAR": PercPUPAR,
            "Duration": Duration,
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }


    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'VersaoDocumento',
            headerName: 'VersaoDocumento',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CETIP',
            headerName: 'CETIP',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'IDUsuario',
            headerName: 'IDUsuario',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },       
        {
            field: 'DataCalculo',
            headerName: 'DataCalculo',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            disableColumnMenu: true,
            editable: true,
            renderCell: (params) => {
                if (!params.value) {
                    return ''
                }
                return dayjs(params.value).format(DATE_FORMAT_SHOW)
            }
        },
        {
            field: 'PUPAR',
            headerName: 'PUPAR',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        }, 
        {
            field: 'PUMTM',
            headerName: 'PUMTM',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        }, 
        {
            field: 'PercPUPAR',
            headerName: 'PercPUPAR',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        }, 
        {
            field: 'Duration',
            headerName: 'Duration',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        }, 
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true}
                useDeleteButton={false}  />
        </div>
    )
}

ParameterEmissaoRendaFixaCadastroControleTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaCadastroControleTable